import { render, staticRenderFns } from "./view-confirm-stock-in.vue?vue&type=template&id=2afcdb9e&scoped=true&"
import script from "./view-confirm-stock-in.vue?vue&type=script&lang=js&"
export * from "./view-confirm-stock-in.vue?vue&type=script&lang=js&"
import style0 from "./view-confirm-stock-in.vue?vue&type=style&index=0&id=2afcdb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcdb9e",
  null
  
)

export default component.exports